import React from 'react';
import TemplatePage from '../../components/TemplatePage/TemplatePage';
import { economicsData } from '../../data/departmentalData/economics';

const Economics = () => {
  return <TemplatePage data={economicsData} />;
};

export default Economics;
